import { useEpisodes } from "@/contexts/EpisodesContext";
import { useMentionCards } from "@/contexts/MentionCardsContext";
import useFilterParams from "@/hooks/useFilterParams";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@components/ui/empty";
import { Trans } from "@lingui/react/macro";
import { Button } from "@components/ui/button";
import { formatDateForApi } from "@/utils";

export default function EmptyTimePeriod({ v4 = false }: { v4?: boolean }) {
  const [{ tag }, setFilters] = useFilterParams();
  const legacyEpisodesResult = useEpisodes();
  const mentionCardsResult = useMentionCards();

  const alert = v4 ? mentionCardsResult.alert : legacyEpisodesResult.alert;

  return (
    <Empty data-testid="empty-period-no-mentions">
      <EmptyHeader>
        <EmptyMedia></EmptyMedia>
        <EmptyTitle>
          <Trans>Inga omnämnanden</Trans>
        </EmptyTitle>
        <EmptyDescription>
          <Trans>Det finns inga träffar under vald period.</Trans>
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button
          variant="outline"
          onClick={(e: unknown) => {
            (e as MouseEvent).preventDefault();
            setFilters(
              {
                tag,
                start_date: tag ? undefined : alert?.start_date,
                end_date: formatDateForApi(new Date()),
              },
              true
            );
          }}
        >
          <Trans>Visa alla</Trans>
        </Button>
      </EmptyContent>
    </Empty>
  );
}
